let setValue = (state, { value, key }) => {
	state[key] = value;
};

let setTrip = (state, trip) => {
	let index = state.tripSearch.trips.findIndex(x => x.id === trip.id);

	if (index === -1) {
		state.tripSearch.trips.push(trip);
	} else {
		state.tripSearch.trips[index] = trip;
		if (state.tripSearch.tripDetails && state.tripSearch.tripDetails.id === trip.id)
			state.tripSearch.tripDetails = state.tripSearch.trips[index];
	}
};

let setTripOrders = (state, { id, orders }) => {
	let index = state.tripSearch.trips.findIndex(x => x.id === id);

	if (index === -1) {
		return;
	} else {
		let { length } = state.tripSearch.trips[index].orders;
		state.tripSearch.trips[index].orders.splice(0, length, ...orders);
		if (state.tripSearch.tripDetails && state.tripSearch.tripDetails.id === id)
			state.tripSearch.tripDetails = state.tripSearch.trips[index];
	}
};

let loadSavedSearch = (state, savedSearch) => {
	if (!savedSearch) return;
	state.loadedSearch = { ...savedSearch };
};

let setMapState = (state, { value, key }) => {
	state.mapState[key] = value;
};


let setSelectedGridOrderIds = function(state, ids) {
	state.gridSelecting = ids.length > 0;
	state.selectedGridOrderIds = ids;
};

let setFilteredGridOrderIds = function(state, ids) {
	state.filteredGridOrderIds = ids;
};

let ordersInMap = function(state, orderIds) {
	if ( state.orderSearch.orders.length === 0) {
		state.mapOrderIds = null;
	} else if (orderIds.length === 0) {
		state.mapOrderIds = [];
	} else {
		state.mapOrderIds = orderIds;
	}
};

let setSelectedMapOrderIds = function(state, ids) {
	state.mapSelecting = ids.length > 0;
	state.selectedMapOrderIds = ids;
};


export default {
	setValue,
	setTrip,
	setTripOrders,
	loadSavedSearch,
	setMapState,
	setSelectedGridOrderIds,
	setFilteredGridOrderIds,
	ordersInMap,
	setSelectedMapOrderIds,
};